export default "__VITE_ASSET__Bah8idgQ__"